import { ICountry, IMapInformation } from '@app/componentlib/common/types/LocationTypes'

export const mapInformationList: IMapInformation[] = [
  {
    Country: 'DK',
    ZipCode: '1113',
    Lat: 55.68,
    Lng: 12.58,
    Radius: 50,
    Zoom: 6,
    IsDraggable: true,
    Interactive: true
  },
  {
    Country: 'SE',
    ZipCode: '11665',
    Lat: 59.31,
    Lng: 18.08,
    Radius: 50,
    Zoom: 6,
    IsDraggable: true,
    Interactive: true
  },
  {
    Country: 'NO',
    ZipCode: '0457',
    Lat: 59.93,
    Lng: 10.75,
    Radius: 50,
    Zoom: 6,
    IsDraggable: true,
    Interactive: true
  },
  {
    Country: 'FI',
    ZipCode: '00260',
    Lat: 60.18,
    Lng: 24.93,
    Radius: 50,
    Zoom: 6,
    IsDraggable: true,
    Interactive: true
  }
]

export const countries: ICountry[] = [
  {
    name: '',
    languageCode: 'da',
    countryCode: 'DK',
    countryName: 'Denmark'
  },
  {
    name: '',
    languageCode: 'sv',
    countryCode: 'SE',
    countryName: 'Sweden'
  },
  {
    name: '',
    languageCode: 'nb',
    countryCode: 'NO',
    countryName: 'Norway'
  },
  {
    name: '',
    languageCode: 'fi',
    countryCode: 'FI',
    countryName: 'Finland'
  }
]

export const validCountries = ['dk', 'no', 'se', 'fi']